import { useTranslation } from "react-i18next";
import CommitteeCardGrid from "./CommitteeCardGrid";
import ScrollDownIndicator from "./ScrollDownIndicator";
import "../styles/Downloads.css";

export default function ExaminationCommitteePageComponent() {
  const { t } = useTranslation();

  const examinationCommitteeData = [
    {
      year: "2026",
      committees: [
        {
          title: "examination_committee_iwe_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
            { name: "prof. dr. ing. habil. IWE Ionel Dănuț SAVU" },
            { name: "prof. dr. ing. Edward PETZEK" },
            { name: "dr. ing. Richard MOLNAR" },
            { name: "conf. dr. ing. Marius BODEA" },
            { name: "conf. dr. ing. Bogdan RADU" },
            { name: "dr. ing. IWI-C Alin-Constantin MURARIU" },
            { name: "dr. ing. Nicușor-Alin SÎRBU" },
            { name: "IWE Pavel Burlui" },
          ],
        },
        {
          title: "examination_committee_iwt_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
            { name: "prof. dr. ing. habil. IWE Ionel Dănuț SAVU" },
            { name: "prof. dr. ing. Edward PETZEK" },
            { name: "dr. ing. Richard MOLNAR" },
            { name: "conf. dr. ing. Marius BODEA" },
            { name: "conf. dr. ing. Bogdan RADU" },
            { name: "dr. ing. IWI-C Alin-Constantin MURARIU" },
            { name: "dr. ing. Nicușor-Alin SÎRBU" },
            { name: "IWE Pavel Burlui" },
          ],
        },
        {
          title: "examination_committee_iws_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
            { name: "prof. dr. ing. habil. IWE Ionel Dănuț SAVU" },
            { name: "prof. dr. ing. Edward PETZEK" },
            { name: "dr. ing. Richard MOLNAR" },
            { name: "conf. dr. ing. Marius BODEA" },
            { name: "conf. dr. ing. Bogdan RADU" },
            { name: "dr. ing. IWI-C Alin-Constantin MURARIU" },
            { name: "dr. ing. Nicușor-Alin SÎRBU" },
            { name: "IWE Pavel Burlui" },
          ],
        },
        {
          title: "examination_committee_iwi_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "ing. IWE Cristian DELAMARIAN" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
            { name: "ing. IWI-C Mircea JIANU" },
          ],
        },
        {
          title: "certification_committee_c_iwe_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
            { name: "prof. dr. ing. habil. IWE Ionel Dănuț SAVU" },
            { name: "prof. dr. ing. Edward PETZEK" },
            { name: "dr. ing. Richard MOLNAR" },
            { name: "conf. dr. ing. Marius BODEA" },
            { name: "conf. dr. ing. Bogdan RADU" },
            { name: "dr. ing. IWI-C Alin-Constantin MURARIU" },
            { name: "dr. ing. Nicușor-Alin SÎRBU" },
            { name: "IWE Pavel Burlui" },
          ],
        },
        {
          title: "examination_committee_iwsd_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
            { name: "prof. dr. ing. habil. IWE Ionel Dănuț SAVU" },
            { name: "prof. dr. ing. Edward PETZEK" },
            { name: "dr. ing. Richard MOLNAR" },
            { name: "conf. dr. ing. Marius BODEA" },
            { name: "conf. dr. ing. Bogdan RADU" },
            { name: "dr. ing. IWI-C Alin-Constantin MURARIU" },
            { name: "dr. ing. Nicușor-Alin SÎRBU" },
            { name: "IWE Pavel Burlui" },
          ],
        },
        {
          title: "examination_committee_rmwf_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "dr. ing. IWI-C Alin-Constantin MURARIU" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
          ],
        },
        {
          title: "examination_committee_iw_title",
          members: [
            { name: "prof. dr. ing. IWI-C Francisc TUSZ" },
            { name: "dr. ing. EWE Horia Florin DAȘCĂU" },
            { name: "dr. ing. EWE Ovidiu VAIDA" },
            { name: "ing. IWE Ioan BAN" },
            { name: "ing. IWE Iosif SIMON" },
          ],
        },
      ],
    },
  ];

  return (
    <div className="downloads-page">
      <div className="downloads-grid-title-container">
        <p className="downloads-grid-title">{t("examination_committee_title")}</p>
        <h1 className="downloads-grid-subtitle">
          {t("examination_committee_subtitle")}
        </h1>
        <p className="downloads-grid-text">
          {t("examination_committee_description")}
        </p>
        <ScrollDownIndicator targetId="examination-committee-content" />
      </div>
      <div className="committee-container" id="examination-committee-content">
        {examinationCommitteeData.map(({ year, committees }) => (
          <section className="committee-year-section" key={year}>
            <h2 className="committee-year-title">{year}</h2>
            <CommitteeCardGrid committeeCardData={committees} />
          </section>
        ))}
      </div>
    </div>
  );
}
